import { render, staticRenderFns } from "./Mousing_Dos_and_Donts.vue?vue&type=template&id=51d3690a"
import script from "./Mousing_Dos_and_Donts.vue?vue&type=script&lang=js"
export * from "./Mousing_Dos_and_Donts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports